import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store";
import { Cost } from "../store/types";
import {
  initializeLocationCosts,
  addCost,
  updateCost,
  removeCost,
  setLocationCosts,
} from "../store/costsSlice";

/**
 * Hook personnalisu00e9 pour gu00e9rer les cou00fbts d'un emplacement spu00e9cifique
 * @param locationId - ID de l'emplacement
 */
export const useLocationCosts = (locationId: string) => {
  const dispatch = useAppDispatch();
  const costs = useAppSelector(
    (state) => state.costs.locations[locationId] || []
  );

  // Initialiser les cou00fbts de l'emplacement seulement s'ils n'existent pas encore
  const initialize = useCallback(() => {
    // Ne pas initialiser si des cou00fbts existent déjà pour cet emplacement
    if (costs.length === 0) {
      dispatch(initializeLocationCosts(locationId));
    }
  }, [dispatch, locationId, costs.length]);

  // Ajouter un nouveau cou00fbt
  const addNewCost = useCallback(() => {
    dispatch(
      addCost({
        locationId,
        cost: {
          id: Date.now().toString(),
          name: "Nouveau coût",
          type: "percentage",
          value: 0,
          isBaseCommission: false,
        },
      })
    );
  }, [dispatch, locationId]);

  // Mettre u00e0 jour un cou00fbt existant
  const updateExistingCost = useCallback(
    (
      costId: string,
      field: "name" | "type" | "value",
      value: string | number
    ) => {
      dispatch(updateCost({ locationId, costId, field, value }));
    },
    [dispatch, locationId]
  );

  // Supprimer un cou00fbt
  const removeExistingCost = useCallback(
    (costId: string) => {
      dispatch(removeCost({ locationId, costId }));
    },
    [dispatch, locationId]
  );

  // Du00e9finir tous les cou00fbts d'un emplacement
  const setAllCosts = useCallback(
    (costs: Cost[]) => {
      dispatch(setLocationCosts({ locationId, costs }));
    },
    [dispatch, locationId]
  );

  return {
    costs,
    initialize,
    addNewCost,
    updateExistingCost,
    removeExistingCost,
    setAllCosts,
  };
};
